import React, { useEffect, useState } from "react";
import { CONNECTION_STATUS } from "../../../../utils/constants";
import OpenToAnythingIconActive from "../../../../assets/theme/images/friendshipActiveIcon.png";
import DatingIconActive from "../../../../assets/theme/images/ConnectionDatingIcon.png";
import FriendshipIconActive from "../../../../assets/theme/images/open2anythingIconActive.png";

interface ConnectionRequestSentWidgetProps {
  guestDetails?: any;
  userDetails?: any;
  requestedConnectionStatus?: any;
  handleRefetchGuestDetails?: any;
  handleChatModal?: any
}

const ConnectionRequestSentWidget: React.FC<
  ConnectionRequestSentWidgetProps
> = ({
  guestDetails,
  userDetails,
  requestedConnectionStatus,
  handleRefetchGuestDetails,
  handleChatModal
}) => {
  const [profilePhoto, setProfilePhoto] = useState("");
  const [requestToName, setRequestToName] = useState("");
  const [requestedConnectionIcon, setRequestedConnectionIcon] = useState("");
  const [requestedConnectionLabel, setRequestedConnectionLabel] = useState("");
  useEffect(() => {
    if (guestDetails && guestDetails?.profilePhoto) {
      setProfilePhoto(guestDetails?.profilePhoto);
    }
    if (guestDetails && (guestDetails?.firstName)) {
      setRequestToName(`${guestDetails?.firstName}`);
    }
    let connectionIcon = OpenToAnythingIconActive;
    let connectionLabel = "Open to Both";
    if (
      requestedConnectionStatus &&
      requestedConnectionStatus === CONNECTION_STATUS.DATING
    ) {
      connectionIcon = DatingIconActive;
      connectionLabel = "Dating";
    } else if (
      requestedConnectionStatus &&
      requestedConnectionStatus === CONNECTION_STATUS.FRIENDSHIP
    ) {
      connectionIcon = FriendshipIconActive;
      connectionLabel = "Friendship/ Professional";
    }
    setRequestedConnectionLabel(connectionLabel);
    setRequestedConnectionIcon(connectionIcon);
  }, []);
  return (
    <div className="w-full md:w-[98%] lg:w-[98%] connection-guest-list mt-2">
      <div className="mt-6 text-center">
        <p className="text-lg text-[#786469]">Request to</p>
        <h3 className="text-xl font-bold text-[#0F090B] font-[PINYADA-Beranda-Regular] tracking-tighterCustom leading-tight-120 tracking-tight-3">
          {requestToName}
        </h3>
      </div>

      <div className="mt-4 relative flex flex-col items-center">
        <div className="flex justify-center items-center">
          <div className="relative w-[20%] flex items-center justify-center">
            <img
              src={profilePhoto}
              alt={requestToName}
              className="w-18 h-18 rounded-full object-cover border-2 border-white shadow-lg"
            />
          </div>
        </div>
      </div>

      <div className="flex justify-center items-center h-48 my-8">
        <div className="grid place-items-center text-center ">
          <img
            src={requestedConnectionIcon}
            alt={requestedConnectionLabel}
            className="cursor-pointer w-[75%]  lg:w-[65%] md:w-[65%] lg:h-auto md:h-auto  object-contain "
          />
          
        </div>
      </div>
      <div className="flex justify-center items-center w-full ">
        <div className="p-2 break-words text-xl font-bold text-[#0F090B]  font-[PINYADA-Beranda-Regular] tracking-tighterCustom leading-tight-120 tracking-tight-3">
              {requestedConnectionLabel}
        </div>
      </div>
     
      <div className="flex justify-center items-center w-full ">
        <button
          onClick={() => handleRefetchGuestDetails()}
          className="mt-4 px-6 py-2 bg-white text-black rounded-full shadow-md border border-white hover:bg-gray-100"
        >
          Okay
        </button>
      </div>
      
    </div>
  );
};

export default ConnectionRequestSentWidget;
